import measured from "./MeasuredModerationUsage.json";

/**
 * Input tokens a token-billed moderation provider used per call, measured by the benchmark on a
 * random sample of real content (`bun src/Cli.ts ... --sampling random --record-usage` in
 * packages/benchmark). The cost model reads these instead of assuming a figure; record again after
 * changing the prompts or the request plan.
 */
export interface MeasuredUsage {
  /** Mean input tokens per call; for text, the fitted tokens at zero characters. */
  inputTokensPerCall: number;
  /** For text: the fitted extra input tokens per character of the moderated text. */
  inputTokensPerCharacter?: number;
  /** Calls measured; absent for figures recorded before the benchmark recorded usage. */
  calls?: number;
  /** Mean characters of the measured texts. */
  meanCharacters?: number;
  dataset: string;
  policyVersion: string;
  measuredAt: string;
}

export type MeasuredProvider = "d1-ultra" | "jev" | "clef-flash" | "clef";
export const MEASURED_MODERATION_USAGE = measured as Record<
  MeasuredProvider,
  Partial<Record<"text" | "image", MeasuredUsage>>
>;
